import type { FC } from "react";

import TutoringDoneIcon from "images/achievements/80-doucko-tutoring-completed.svg?url";
import CheckIcon from "images/achievements/18-check.svg?url";
import type { ThemeProgress as IThemeProgress } from "utils/common/themes";

interface Props {
  progress: IThemeProgress;
  isBadge: boolean;
}

const ThemeProgress: FC<Props> = ({ progress, isBadge }) => {
  const countProgress = () => {
    if (progress.fixedCount > progress.fixedFinished) {
      const count = progress.fixedCount + (progress.videoCount > 0 ? 1 : 0);
      const finished =
        progress.fixedFinished + (progress.videoCount ? Math.floor(progress.videoFinished / progress.videoCount) : 0);
      return finished / count;
    }

    if (progress.othersCount === 0) return null;

    return progress.othersFinished / progress.othersCount;
  };

  const progressRatio = countProgress();

  return (
    <>
      {isBadge && (
        <div className="d-flex align-items-center justify-content-center">
          <img src={TutoringDoneIcon} width="30" height="30" alt="" />
        </div>
      )}

      {progressRatio === null || (progressRatio === 0 && !isBadge) ? null : (
        <div className="progress-bar align-items-center justify-content-center">
          {progressRatio === 1 ? (
            <img src={CheckIcon} width="18" height="18" alt="" />
          ) : (
            <div className="progress-bar__wrapper">
              <div className="progress-bar--completed" style={{ width: `${progressRatio * 100}%` }} />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ThemeProgress;
